import { Checkbox, FormControlLabel } from '@mui/material';
import { FormikProps } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import {
  CHECKBOX_CHECKED_VALUE,
  CHECKBOX_UNCHECKED_VALUE,
  FormBodyAPI,
} from 'src/constants';

interface FormValues {
  label: string;
  // 'checked' | 'unchecked'
  value: string;
}

// Signing-side checkbox: the client toggles the value. The label is rendered as the
// panel title (the client cannot edit it), so the form only carries the checked state.
// Required-vs-optional gating lives in SignatureClientFormV2's isButtonDisabled.
export const useClientCheckboxForm = () => {
  const validationScheme = Yup.object().shape({});

  const getSubmitValues = () => Promise.resolve({});

  const FormRenderer: React.FC<FormBodyAPI<FormValues>> = (props) => {
    const { values, setFieldValue } = props as FormikProps<FormValues>;
    const isChecked = values.value === CHECKBOX_CHECKED_VALUE;

    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            name="value"
            onChange={() =>
              setFieldValue(
                'value',
                isChecked ? CHECKBOX_UNCHECKED_VALUE : CHECKBOX_CHECKED_VALUE,
              )
            }
            color="primary"
            // Comfortable tap target on mobile (>= 44x44).
            sx={{ padding: 1.5 }}
            data-testid="client-checkbox-toggle"
          />
        }
        label={values.label || ''}
      />
    );
  };

  return { validationScheme, getSubmitValues, FormRenderer };
};
